import { useMutation, gql } from '@apollo/client';
import {
  EditarTurmaMutation,
  EditarTurmaMutationVariables,
} from './__generated__/EditarTurmaMutation';

const EDITAR_TURMA_MUTATION = gql`
  mutation EditarTurmaMutation(
    $id_turma: Int!
    $id_horario: Int
    $num_turma: Int
    $dias_semana: Int
    $ativa: Boolean
  ) {
    editarTurma(
      input: {
        id_turma: $id_turma
        id_horario: $id_horario
        num_turma: $num_turma
        dias_semana: $dias_semana
        ativa: $ativa
      }
    ) {
      id_turma
      id_horario
      num_turma
      dias_semana
      ativa
    }
  }
`;

const useEditarTurmaMutation = () => {
  return useMutation<EditarTurmaMutation, EditarTurmaMutationVariables>(EDITAR_TURMA_MUTATION);
};

export { useEditarTurmaMutation };
